import { useQuery } from '@pinia/colada';
import { computed } from 'vue';
import { useRoute } from 'vue-router';

import applicationsService from '../services/applications.service';

export function usePropertyApplicationBundlesQuery() {
  const route = useRoute();
  const propertyId = computed(() => route.params.propertyId as string);

  return useQuery({
    key: () => ['property', propertyId.value, 'application-bundles'],
    query: () => applicationsService.getBundlesByProperty(propertyId.value),
  });
}
